"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivationFlow = exports.SecondScreenEntryPoint = exports.SignInAndSubscriptionPurchaseProcessStatus = exports.SignInStatus = void 0;
var SignInStatus;
(function (SignInStatus) {
    SignInStatus["NotStarted"] = "notStarted";
    SignInStatus["Started"] = "started";
    SignInStatus["Succeeded"] = "succeeded";
    SignInStatus["Failed"] = "failed";
    SignInStatus["Cancelled"] = "cancelled";
})(SignInStatus = exports.SignInStatus || (exports.SignInStatus = {}));
var SignInAndSubscriptionPurchaseProcessStatus;
(function (SignInAndSubscriptionPurchaseProcessStatus) {
    SignInAndSubscriptionPurchaseProcessStatus["NotStarted"] = "notStarted";
    SignInAndSubscriptionPurchaseProcessStatus["Started"] = "started";
    SignInAndSubscriptionPurchaseProcessStatus["SignedIn"] = "signedIn";
    SignInAndSubscriptionPurchaseProcessStatus["Succeeded"] = "succeeded";
    SignInAndSubscriptionPurchaseProcessStatus["Failed"] = "failed";
})(SignInAndSubscriptionPurchaseProcessStatus = exports.SignInAndSubscriptionPurchaseProcessStatus || (exports.SignInAndSubscriptionPurchaseProcessStatus = {}));
var SecondScreenEntryPoint;
(function (SecondScreenEntryPoint) {
    SecondScreenEntryPoint["MvpdLogin"] = "mvpdLogin";
    SecondScreenEntryPoint["ViacomAccountSignUp"] = "viacomAccountSignUp";
    SecondScreenEntryPoint["ViacomAccountSignIn"] = "viacomAccountSignIn";
})(SecondScreenEntryPoint = exports.SecondScreenEntryPoint || (exports.SecondScreenEntryPoint = {}));
var ActivationFlow;
(function (ActivationFlow) {
    ActivationFlow["SignIn"] = "signIn";
    ActivationFlow["Subscription"] = "subscription";
})(ActivationFlow = exports.ActivationFlow || (exports.ActivationFlow = {}));
